module.exports = __webpack_public_path__ + "img/logo.e1466a51.png";